import {
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Row,
  Col,
  Switch,
  Flex
} from "antd";
import { useState, useEffect } from "react";
import { Infinity } from "lucide-react"

const PackageForm = ({ visible, onCreate, onCancel, record, businessType }) => {
  const [form] = Form.useForm();
  const [selectedBusinessType, setSelectedBusinessType] = useState(null);
  const [isReferralPer, setIsReferralPer] = useState(true);
  const [unlimitedFields, setUnlimitedFields] = useState({
    noOfCompanies: false,
    noOfEways: false,
    noOfEInvoice: false,
    noOfUser: false,
    noOfWp: false,
  });

  // const productOptions = [
  //   { id: 1, name: "09 TAX" },
  //   { id: 2, name: "ECOMMGPT" },
  //   { id: 3, name: "OFFICE CRM" },
  // ];

  const dueTypeOptions = [
    { id: "DAY", name: "Day" },
    { id: "MONTH", name: "Month" },
    { id: "YEAR", name: "Year" },
  ];

  useEffect(() => {
    if (record) {
      // const productArray = Array.isArray(record.product)
      //   ? record.product
      //   : record.product
      //   ? [record.product]
      //   : [];

      // Ensure isDemo is properly converted to number
      const isDemoValue =
        record.isDemo === true || record.isDemo === 1 || record.isDemo === "1"
          ? true
          : false;
      form.setFieldsValue({
        name: record.name,
        description: record.description,
        // grossAmt: record.grossAmt,
        discPer: record.discPer,
        discAmt: record.discAmt,
        amcPeriod: record.amcPeriod,
        durType: record.durType,
        amcPrice: record.amcPrice,
        detail: record.detail,
        isDemo: isDemoValue,
        businessType: record.businessType,
        product: [1],
        noOfCompanies:
          record.noOfCompanies === -100 ? "Unlimited" : record.noOfCompanies,
        noOfEways: record.noOfEways === -100 ? "Unlimited" : record.noOfEways,
        noOfEInvoice:
          record.noOfEInvoice === -100 ? "Unlimited" : record.noOfEInvoice,
        noOfUser: record.noOfUser === -100 ? "Unlimited" : record.noOfUser,
        noOfWp: record.noOfWp === -100 ? "Unlimited" : record.noOfWp,
        isMobileApp: record.isMobileApp,
        isCrm: record.isCrm,
        isRojmel: record.isRojmel,
        isToDo: record.isToDo,
        isDailyWp: record.isDailyWp,
        referralAmt: record.referralAmt,
        referralPer: record.referralPer,
        isDashboardGst: record.isDashboardGst,
        is2a2b: record.is2a2b,
        is2stepVerify: record.is2stepVerify,
        sales_challan: record.sales_challan,
        sales_invoice: record.sales_invoice,
        purchase_challan: record.purchase_challan,
        purchase_invoice: record.purchase_invoice,
        sales_return: record.sales_return,
        purchase_return: record.purchase_return,
        issue: record.issue,
        receive: record.receive,
        cash: record.cash,
        bank: record.bank,
        jv: record.jv,
        stock_transfer: record.stock_transfer,
        share_company: record.share_company,
        company_wise_master: record.company_wise_master,
        delete_unused_master: record.delete_unused_master,
        aamne_saamne_sale_purchase: record.aamne_saamne_sale_purchase,
        multiple_eway_bill_generate: record.multiple_eway_bill_generate,
        print_barcode: record.print_barcode,
        sales_order: record.sales_order,
        purchase_order: record.purchase_order,
        bank_import: record.bank_import,
        bulk_update_suspense_account: record.bulk_update_suspense_account,
      });
      setSelectedBusinessType(record.businessType);
    } else {
      form.resetFields();
      setSelectedBusinessType(null);
    }
  }, [record, form]);

  useEffect(() => {
    if (record) {
      setUnlimitedFields({
        noOfCompanies: record.noOfCompanies === -100 ? true : false,
        noOfEways: record.noOfEways === -100 ? true : false,
        noOfEInvoice: record.noOfEInvoice === -100 ? true : false,
        noOfUser: record.noOfUser === -100 ? true : false,
        noOfWp: record.noOfWp === -100 ? true : false,
      });
    }
  }, [record]);

  const handleBusinessChange = (value) => {
    setSelectedBusinessType(value);
  };

  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  return (
    <Modal
      open={visible}
      title={record ? "Update Package" : "Add Package"}
      okText="Submit"
      cancelText="Cancel"
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            values.isDemo = values.isDemo === 1 ? true : false;
            values.noOfCompanies =
              values.noOfCompanies === "Unlimited"
                ? -100
                : values.noOfCompanies;
            values.noOfEways =
              values.noOfEways === "Unlimited" ? -100 : values.noOfEways;
            values.noOfEInvoice =
              values.noOfEInvoice === "Unlimited" ? -100 : values.noOfEInvoice;
            values.noOfUser =
              values.noOfUser === "Unlimited" ? -100 : values.noOfUser;
            values.noOfWp =
              values.noOfWp === "Unlimited" ? -100 : values.noOfWp;

            onCreate(values);
            setUnlimitedFields({
              noOfCompanies: false,
              noOfEways: false,
              noOfEInvoice: false,
              noOfUser: false,
              noOfWp: false,
            });
            form.resetFields();
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
      width={1200}
      height={750}
      centered
      bodyStyle={{ paddingTop: 20 }}
    >
      <Form
        {...formItemLayout}
        form={form}
        layout="vertical"
        name="package_form"
      >
        <Row gutter={24}>
          <Col span={6}>
            <Form.Item
              name="name"
              label="Name"
              rules={[
                { required: true, message: "Please enter the package name!" },
              ]}
            >
              <Input placeholder="Enter name" />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="description"
              label="Description"
              rules={[
                {
                  required: true,
                  message: "Please enter the package description!",
                },
              ]}
            >
              <Input placeholder="Enter description" />
            </Form.Item>
          </Col>

          {/* <Col span={12}>
            <Form.Item
              name="grossAmt"
              label="Gross Amount"
              rules={[
                { required: true, message: "Please enter the gross amount!" },
              ]}
            >
              <InputNumber
                placeholder="Enter amount"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col> */}
          <Col span={6}>
            <Form.Item
              name="discPer"
              label="Discount (%)"
              rules={[
                {
                  required: true,
                  message: "Please enter the discount percentage!",
                },
                { type: "number", message: "Must be a valid percentage!" },
              ]}
            >
              <InputNumber
                placeholder="Enter %"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="discAmt"
              label="Discount Amount"
              rules={[
                {
                  required: true,
                  message: "Please enter the discount amount!",
                },
              ]}
            >
              <InputNumber
                placeholder="Enter discount amount"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="amcPeriod"
              label="AMC Period"
              rules={[
                { required: true, message: "Please enter the AMC period!" },
              ]}
            >
              <InputNumber
                placeholder="Enter period in months"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="durType"
              label="Dur Type"
              rules={[
                {
                  required: true,
                  message: "Please select at least one Dur Type!",
                },
              ]}
            >
              <Select
                placeholder="Select Type"
                style={{ width: "100%" }}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {dueTypeOptions.map((product) => (
                  <Select.Option key={product.id} value={product.id}>
                    {product.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="amcPrice"
              label="AMC Price"
              rules={[
                { required: true, message: "Please enter the AMC price!" },
              ]}
            >
              <InputNumber
                placeholder="Enter AMC price"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="detail"
              label="Detail"
              rules={[{ required: true, message: "Please enter the detail!" }]}
            >
              <Input placeholder="Enter details" />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="isDemo"
              label="Demo"
              rules={[
                { required: true, message: "Please specify if it is a demo!" },
              ]}
            >
              <Select placeholder="Select">
                <Select.Option value={1}>Yes</Select.Option>
                <Select.Option value={0}>No</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="businessType"
              label="Business Type"
              rules={[
                { required: true, message: "Please select a Business Type!" },
              ]}
            >
              <Select
                placeholder="Select Business Type"
                onChange={handleBusinessChange}
                value={selectedBusinessType}
              >
                {businessType.map(({ id, type }) => (
                  <Select.Option key={id} value={id}>
                    {type}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          {/* <Col span={12}>
            <Form.Item
              name="product"
              label="Products"
              rules={[
                {
                  required: true,
                  message: "Please select at least one product!",
                },
                {
                  type: "array",
                  min: 1,
                  message: "Please select at least one product!",
                },
              ]}
            >
              <Select
                mode="multiple"
                placeholder="Select Products"
                style={{ width: "100%" }}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {productOptions.map((product) => (
                  <Select.Option key={product.id} value={product.id}>
                    {product.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col> */}

          <Col span={6}>
            <Form.Item name="isReferralPer" label="Referral Per">
              <Switch onChange={(e) => setIsReferralPer(e)} />
            </Form.Item>
          </Col>

          {isReferralPer ? (
            <Col span={6}>
              <Form.Item name="referralAmt" label="Referral Amount">
                <InputNumber
                  placeholder="Enter Referral Amt"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          ) : (
            <Col span={6}>
              <Form.Item name="referralPer" label="Referral Per">
                <InputNumber
                  placeholder="Enter Referral Per"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          )}

          {/* <Col span={4}>
            <Form.Item label="Unlimited Companies">
              <Switch
                checked={unlimitedFields.noOfCompanies}
                onChange={(checked) => {
                  setUnlimitedFields((prev) => ({
                    ...prev,
                    noOfCompanies: checked,
                  }));
                  if (unlimitedFields.noOfCompanies)
                    form.setFieldValue("noOfCompanies", "");
                  else form.setFieldValue("noOfCompanies", "Unlimited");
                }}
              />
            </Form.Item>
          </Col> */}
          <Col span={4}>
            <Form.Item
              name="noOfCompanies"
              label="No Of Companies"
              rules={[
                {
                  required: true,
                  message: "Please enter the No Of Companies!",
                },
              ]}
            >
              <Flex gap="middle" justify="start" align="center">

                {unlimitedFields.noOfCompanies ? (
                  <Input
                    placeholder="Enter No Of Companies"
                    style={{ width: "100%" }}
                    disabled
                  />
                ) : (
                  <InputNumber
                    placeholder="Enter No Of Companies"
                    style={{ width: "100%" }}
                  />
                )}
                <Switch
                  checked={unlimitedFields.noOfCompanies}
                  checkedChildren={<Infinity width={20} style={{ paddingBottom: "3px", marginRight: "40px" }} />}
                  // checkedChildren={<span style={{ fontSize: "20px", marginRight: "40px", marginBottom: "30px" }}>∞</span>}
                  onChange={(checked) => {
                    setUnlimitedFields((prev) => ({
                      ...prev,
                      noOfCompanies: checked,
                    }));
                    if (unlimitedFields.noOfCompanies)
                      form.setFieldValue("noOfCompanies", "");
                    else form.setFieldValue("noOfCompanies", "Unlimited");
                  }}
                />
              </Flex>
            </Form.Item>
          </Col>

          {/* <Col span={4}>
            <Form.Item label="Unlimited Eways">
              <Switch
                checked={unlimitedFields.noOfEways}
                onChange={(checked) => {
                  setUnlimitedFields((prev) => ({
                    ...prev,
                    noOfEways: checked,
                  }));
                  if (unlimitedFields.noOfEways)
                    form.setFieldValue("noOfEways", "");
                  else form.setFieldValue("noOfEways", "Unlimited");
                }}
              />
            </Form.Item>
          </Col> */}
          <Col span={4}>
            <Form.Item
              name="noOfEways"
              label="No Of Eways"
              rules={[
                {
                  required: true,
                  message: "Please enter the No Of Eways!",
                },
              ]}
            >
              <Flex gap="middle" justify="start" align="center">
                {unlimitedFields.noOfEways ? (
                  <Input
                    placeholder="Enter No Of Eways"
                    style={{ width: "100%" }}
                    disabled
                  />
                ) : (
                  <InputNumber
                    placeholder="Enter No Of Eways"
                    style={{ width: "100%" }}
                  />
                )}
                <Switch
                  checked={unlimitedFields.noOfEways}
                  checkedChildren={<Infinity width={20} style={{ paddingBottom: "3px", marginRight: "40px" }} />}
                  onChange={(checked) => {
                    setUnlimitedFields((prev) => ({
                      ...prev,
                      noOfEways: checked,
                    }));
                    if (unlimitedFields.noOfEways)
                      form.setFieldValue("noOfEways", "");
                    else form.setFieldValue("noOfEways", "Unlimited");
                  }}
                />
              </Flex>
            </Form.Item>
          </Col>

          {/* <Col span={4}>
            <Form.Item label="Unlimited EInvoice">
              <Switch
                checked={unlimitedFields.noOfEInvoice}
                onChange={(checked) => {
                  setUnlimitedFields((prev) => ({
                    ...prev,
                    noOfEInvoice: checked,
                  }));
                  if (unlimitedFields.noOfEInvoice)
                    form.setFieldValue("noOfEInvoice", "");
                  else form.setFieldValue("noOfEInvoice", "Unlimited");
                }}
              />
            </Form.Item>
          </Col> */}
          <Col span={4}>
            <Form.Item
              name="noOfEInvoice"
              label="No Of EInvoice"
              rules={[
                {
                  required: true,
                  message: "Please enter the No Of EInvoice!",
                },
              ]}
            >
              <Flex gap="middle" justify="start" align="center">
                {unlimitedFields.noOfEInvoice ? (
                  <Input
                    placeholder="Enter No Of EInvoice"
                    style={{ width: "100%" }}
                    disabled
                  />
                ) : (
                  <InputNumber
                    placeholder="Enter No Of EInvoice"
                    style={{ width: "100%" }}
                  />
                )}
                <Switch
                  checked={unlimitedFields.noOfEInvoice}
                  checkedChildren={<Infinity width={20} style={{ paddingBottom: "3px", marginRight: "40px" }} />}
                  onChange={(checked) => {
                    setUnlimitedFields((prev) => ({
                      ...prev,
                      noOfEInvoice: checked,
                    }));
                    if (unlimitedFields.noOfEInvoice)
                      form.setFieldValue("noOfEInvoice", "");
                    else form.setFieldValue("noOfEInvoice", "Unlimited");
                  }}
                />
              </Flex>
            </Form.Item>
          </Col>

          {/* <Col span={4}>
            <Form.Item label="Unlimited User">
              <Switch
                checked={unlimitedFields.noOfUser}
                onChange={(checked) => {
                  setUnlimitedFields((prev) => ({
                    ...prev,
                    noOfUser: checked,
                  }));
                  if (unlimitedFields.noOfUser)
                    form.setFieldValue("noOfUser", "");
                  else form.setFieldValue("noOfUser", "Unlimited");
                }}
              />
            </Form.Item>
          </Col> */}
          <Col span={4}>
            <Form.Item
              name="noOfUser"
              label="No Of User"
              rules={[
                {
                  required: true,
                  message: "Please enter the No Of User!",
                },
              ]}
            >
              <Flex gap="middle" justify="start" align="center">
                {unlimitedFields.noOfUser ? (
                  <Input
                    placeholder="Enter No Of User"
                    style={{ width: "100%" }}
                    disabled
                  />
                ) : (
                  <InputNumber
                    placeholder="Enter No Of User"
                    style={{ width: "100%" }}
                  />
                )}
                <Switch
                  checked={unlimitedFields.noOfUser}
                  checkedChildren={<Infinity width={20} style={{ paddingBottom: "3px", marginRight: "40px" }} />}
                  onChange={(checked) => {
                    setUnlimitedFields((prev) => ({
                      ...prev,
                      noOfUser: checked,
                    }));
                    if (unlimitedFields.noOfUser)
                      form.setFieldValue("noOfUser", "");
                    else form.setFieldValue("noOfUser", "Unlimited");
                  }}
                />
              </Flex>
            </Form.Item>
          </Col>

          {/* <Col span={4}>
            <Form.Item label="Unlimited WP">
              <Switch
                checked={unlimitedFields.noOfWp}
                onChange={(checked) => {
                  setUnlimitedFields((prev) => ({ ...prev, noOfWp: checked }));
                  if (unlimitedFields.noOfWp) form.setFieldValue("noOfWp", "");
                  else form.setFieldValue("noOfWp", "Unlimited");
                }}
              />
            </Form.Item>
          </Col> */}

          <Col span={4}>
            <Form.Item
              name="noOfWp"
              label="No Of Wp"
              rules={[
                {
                  required: true,
                  message: "Please enter the No Of Wp!",
                },
              ]}
            >
              <Flex gap="middle" justify="start" align="center">
                {unlimitedFields.noOfWp ? (
                  <Input
                    placeholder="Enter No Of Wp"
                    style={{ width: "100%" }}
                    disabled
                  />
                ) : (
                  <InputNumber
                    placeholder="Enter No Of Wp"
                    style={{ width: "100%" }}
                  />
                )}
                <Switch
                  checked={unlimitedFields.noOfWp}
                  checkedChildren={<Infinity width={20} style={{ paddingBottom: "3px", marginRight: "40px" }} />}
                  onChange={(checked) => {
                    setUnlimitedFields((prev) => ({
                      ...prev,
                      noOfWp: checked,
                    }));
                    if (unlimitedFields.noOfWp)
                      form.setFieldValue("noOfWp", "");
                    else form.setFieldValue("noOfWp", "Unlimited");
                  }}
                />
              </Flex>
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="sales_invoice" label="Sales Invoice">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="sales_order" label="Sales Order">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="sales_challan" label="Sales Challan">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="sales_return" label="Sales Return">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="purchase_invoice" label="Purchase Invoice">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="purchase_order" label="Purchase Order">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="purchase_challan" label="Purchase Challan">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="purchase_return" label="Purchase Return">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="issue" label="Issue">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="receive" label="Receive">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="cash" label="Cash">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="bank" label="Bank">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="jv" label="JV">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="share_company" label="Share Company">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="stock_transfer" label="Stock Transfer">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="company_wise_master" label="Company Wish Master">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="delete_unused_master" label="Delete Unused Master">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="print_barcode" label="Print Barcode">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="isMobileApp" label="Mobile App">
              <Switch />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="isCrm" label="Crm">
              <Switch />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="isRojmel" label="Rojmel">
              <Switch />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="isToDo" label="ToDo">
              <Switch />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="isDailyWp" label="Daily Wp">
              <Switch />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="is2a2b" label="2A2B">
              <Switch />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="isDashboardGst" label="Dashboard Gst">
              <Switch />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="is2stepVerify" label="Two Step Verify">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item name="bank_import" label="Bank Import">
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item
              name="aamne_saamne_sale_purchase"
              label="Aamne - Saamne Sale Purchase"
            >
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item
              name="multiple_eway_bill_generate"
              label="Multiple Eway Bill Generate"
            >
              <Switch />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item
              name="bulk_update_suspense_account"
              label="Bulk Update Suspense Account"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default PackageForm;
